<template>
  <div class="galleries-section py-5">
    <LoadingWidget v-if="loading" />
    <transition name="fade">
      <v-container v-if="!loading && galleries.length">
        <v-row>
          <v-col
            v-for="({ title, img, to }, itemKey) in galleries"
            :key="itemKey"
            cols="12"
            sm="6"
            md="3"
            class="galleries-section-item"
          >
            <v-card class="galleries-section-item-card" flat :to="to">
              <img width="100%" class="d-block" :src="img" :alt="title" />
              <v-card-title
                class="
                  title
                  text-h6 text-sm-h5 text-uppercase
                  font-weight-medium
                  grey--text
                  d-flex
                  justify-center
                "
              >
                <span class="font-barlow">{{ title }}</span>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </transition>
  </div>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import LoadingWidget from "../widgets/LoadingWidget.vue";

const _config = {
  mod: "galleries",
  path: "/eventos",
};
export default {
  data: () => ({
    loading: true,
    galleries: [],
    path: _config.path,
  }),
  created() {
    this.getGalleries();
  },
  methods: {
    getGalleries() {
      this.loading = true;
      const params = {
        itemsPerPage: 4,
      };
      this.$rest(_config.mod)
        .get({ params })
        .then((galleries) => {
          this.galleries = galleries.map(({ id, title, img }) => ({
            id,
            title,
            img: this.files + img + "?resize=1&w=600",
            to: `${this.path}/${formatToURL(title)}-${id}`,
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.galleries-section-item {
  &-card {
    img {
      aspect-ratio: 263/140;
      object-fit: cover;
      border-radius: 8px !important;
    }
    &:hover {
      span {
        color: var(--v-secondary-base) !important;
        transition: all 0.2s ease;
      }
    }
  }
}
</style>
